/* Form Component.
 *
 * onSubmit can be a string indicating the name of the endpoint
 * to post to on our server, or a custom function that returns
 * a promise
 */

import { createContext, useContext, useState } from "react";
import { useForm } from "react-hook-form/dist/index.ie11";
import API from "../utilities/API";

const FormContext = createContext({});

FormProvider.propTypes = {
  children: PropTypes.node,
  onSubmit: PropTypes.oneOfType([PropTypes.func, PropTypes.string]).required,
  additionalData: PropTypes.object,
  onSuccess: PropTypes.func,
};

FormProvider.propTypes = {
  children: PropTypes.node,
  onSubmit: "contact_us",
  additionalData: {},
};

export default function FormProvider({
  children,
  onSubmit,
  additionalData,
  onSuccess,
}) {
  const { handleSubmit, control, errors, register } = useForm();

  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);

  const renderFields = () => !success && children;

  const renderThankYou = () =>
    success && (
      <div className="form__thank_you">
        <p>Thanks! We will be in touch.</p>
      </div>
    );

  const renderError = () =>
    error &&
    !success && (
      <div>
        <p>{error}</p>
      </div>
    );

  const submitHandler = handleSubmit((formData) => {
    let api = new API({ base: API_PATH });
    let submit = api.post.bind(api, onSubmit);

    if (typeof onSubmit === "function") {
      submit = onSubmit;
    }

    submit({ ...formData, ...additionalData })
      .then((resp) => {
        console.log(resp);
        if (resp.error) {
          return setError(error.message || "An error occurred.");
        }
        if (onSuccess) onSuccess();
        setSuccess(true);
      })
      .catch((error) => {
        console.error(error);
        setError(error.message || "An error occurred.");
      });
  });

  return (
    <FormContext.Provider
      value={{
        control,
        register,
        errors,
      }}
    >
      <form className="form" onSubmit={submitHandler}>
        {renderFields()}
        {renderThankYou()}
        {renderError()}
      </form>
    </FormContext.Provider>
  );
}

export function useFormContext() {
  return useContext(FormContext);
}
